import React from "react";
import { Card } from "./ui/card";
import { Calendar } from "lucide-react";

export default function ResultsTable({ title, subtitle, date, rows, accent = "amber" }) {
  return (
    <Card className="bg-[#11172a] border-amber-400/15 overflow-hidden rounded-2xl">
      <div className="px-6 py-5 border-b border-white/5 flex items-start justify-between gap-4">
        <div>
          <h3 className="text-lg md:text-xl font-bold text-slate-100">{title}</h3>
          {subtitle && <p className="text-xs text-slate-400 mt-0.5">{subtitle}</p>}
        </div>
        <div className="inline-flex items-center gap-1.5 text-xs text-slate-300 bg-white/5 px-2.5 py-1 rounded-md whitespace-nowrap">
          <Calendar className="w-3.5 h-3.5 text-amber-300" />
          {date}
        </div>
      </div>

      <div className="max-h-[420px] overflow-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#0e1424] z-10">
            <tr className="text-left text-[11px] uppercase tracking-wider text-slate-400">
              <th className="px-6 py-3 font-medium">Time</th>
              <th className="px-6 py-3 font-medium text-right">Number</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-t border-white/5 hover:bg-white/[0.03] transition-colors">
                <td className="px-6 py-3 text-slate-300 font-mono">{r.time}</td>
                <td className={`px-6 py-3 text-right font-mono font-bold text-${accent}-300 text-base`}>{r.number}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
